import { vinSchema } from "@qivia/schemas-shared";
import { z } from "zod";

export const tripsBuilderOdometerResponseSchema = z.array(
  z.object({
    vin: vinSchema,
    date: z.coerce.date(),
    mileage: z.number(),
  }),
);

export type TripsBuilderOdometerResponse = z.infer<
  typeof tripsBuilderOdometerResponseSchema
>;
